import Page from 'src/pages/features/firsthalfsale_2025';
import { setupApp } from '@/server/setupApp';
import {
  getPublicTellers,
  getPublicPlans,
  getReviewsOrderByTextCountPriorityProfileHighlight,
  getTodaySchedules,
  getActiveRooms,
  getCategories,
  getViews,
  getFortuneMethods,
} from '@raysee/firestore';

export const getServerSideProps = async () => {
  setupApp();
  const [tellers, plans, reviews, schedules, rooms, categories, views, fortuneMethods] =
    await Promise.all([
      getPublicTellers(),
      getPublicPlans(),
      getReviewsOrderByTextCountPriorityProfileHighlight(),
      getTodaySchedules(),
      getActiveRooms(),
      getCategories(),
      getViews(),
      getFortuneMethods(),
    ]);
  return {
    props: {
      tellers,
      plans,
      reviews,
      schedules,
      rooms,
      categories,
      views,
      fortuneMethods,
    },
  };
};

export default Page;
